const BLUE = 'Blue';

export { BLUE };
